import { render, staticRenderFns } from "./DikeWriteBody.vue?vue&type=template&id=38498f9f&scoped=true"
import script from "./DikeWriteBody.vue?vue&type=script&lang=js"
export * from "./DikeWriteBody.vue?vue&type=script&lang=js"
import style0 from "./DikeWriteBody.vue?vue&type=style&index=0&id=38498f9f&prod&scoped=true&lang=scss"
import style1 from "./DikeWriteBody.vue?vue&type=style&index=1&id=38498f9f&prod&scoped=true&lang=scss"
import style2 from "./DikeWriteBody.vue?vue&type=style&index=2&id=38498f9f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38498f9f",
  null
  
)

export default component.exports